package ui

import ConfigFile
import Flavor
import androidx.lifecycle.ViewModel
import kotlinx.coroutines.flow.StateFlow
import model.ConsumerInformationV3
import model.DataRepository
import model.MerchantFullInformationV3
import model.NavigationRepository
import model.NavigationRepository.DialogState
import navigation.NavigationState
import ui.snackbars.SnackBarState

class NavigationViewModel(
    private val flavor: Flavor,
    val clientConfig: ConfigFile,
    private val dataRepository: DataRepository,
    private val navigationRepository: NavigationRepository
) : ViewModel() {

    val clientName = flavor.clientName

    private val dialogStateMutableStateFlow = navigationRepository.dialogStateMutableStateFlow
    val dialogStateStateFlow = dialogStateMutableStateFlow

    val merchantInformationStateFlow: StateFlow<MerchantFullInformationV3?> = dataRepository.merchantInformationStateFlow
    val consumerInformationStateFlow: StateFlow<ConsumerInformationV3?> = dataRepository.consumerInformationStateFlow

    val navigationStateFlow: StateFlow<NavigationState> = navigationRepository.navigationStateFlow
    val backStackStateFlow: StateFlow<List<NavigationState>> = navigationRepository.backStackStateFlow
    val snackbarStateStateFlow: StateFlow<SnackBarState> = navigationRepository.snackbarStateStateFlow

    val showAppFullScreen: StateFlow<Boolean> = dataRepository.showAppFullScreen

    fun hashStateChangeEvent(newHash: String, locationListener: (String) -> Unit) {
        navigationRepository.hashStateChangeEvent(newHash, locationListener)
    }

    fun popBackStack() {
        navigationRepository.popBackStack()
    }

    fun getToken(): String? {
        return dataRepository.getToken()
    }

    fun requestLogOut() {
        dialogStateMutableStateFlow.value = DialogState.LogOutConfirmation {
            dialogStateMutableStateFlow.value = DialogState.Nothing()
            if (it) {
                dataRepository.logOut()
            }
        }
    }

    fun openSearchScreen() {
        navigationRepository.navigate(NavigationState.Search())
    }

    fun openNearMe() {
        navigationRepository.navigate(NavigationState.NearMe())
    }
}